<template>
    <div v-if="softwareInfo">
        <section class="main-slider">
            <div class="page-header-bg" :style="{backgroundImage: softwareInfo.bannerUrl}">
            </div>
            <div class="container">
                <div class="page-header__inner">
                    <h1>
                        <!-- {{ softwareInfo.title }} -->
                          {{ $t(`software.${softwareInfo.i18n_title}`) }}
					<span style="color: var(--bs-orange);">{{ softwareInfo.title_abb }}</span></h1>
                    <div class="page-header__inner_text">
                        <!-- {{ softwareInfo.text }} -->
                          {{ $t(`software.${softwareInfo.i18n_text}`) }}
                    </div>
                 
                </div>
                
            </div>
        </section>
      

		<section class="blog-details">
            <div class="container">
                <div class="row" >
					<div class="col-xl-12 col-lg-12" >
                        <p class="rf_text rfc_margin">
                            <!-- {{ softwareInfo.introduceText }}  -->
                              {{ $t(`software.${softwareInfo.i18n_introduceText}`) }}
                        </p>
                    </div>
                    <div class="col-xl-12 col-lg-12" >
                        <p class="rf_title">
                            <!-- {{ softwareInfo.solutionTitle }} -->
                            {{  $t(`software.${softwareInfo.i18n_solutionTitle}`) }}
                        </p>
                        <p style="text-align: center;">
                            <img class="row_img" :src="softwareInfo.i18n_solutionImg" />
                        </p>
                    </div>
                    <div class="col-xl-12 col-lg-12" >
                        <p class="rf_title">
                            <!-- {{ softwareInfo.cloudArchitectureTitle }} -->
                              {{  $t(`software.${softwareInfo.i18n_cloudArchitectureTitle}`) }}
                        </p>
                        <p style="text-align: center;">
                            <img class="row_img" :src="softwareInfo.i18n_cloudArchitecture" />
                        </p>
                        <p style="text-align: center;">
                            <img class="row_img" :src="softwareInfo.i18n_weldingFlowChart" />
                        </p>
                    </div>
                    <div class="col-xl-12 col-lg-12" >
                        <p class="rf_text rfc_margin">
                            <!-- {{ softwareInfo.text1 }}  -->
                            {{  $t(`software.${softwareInfo.i18n_text1}`)  }}
                        </p>
                        <p class="rf_text rfc_margin">
                            <!-- {{ softwareInfo.text2 }}  -->
                              {{  $t(`software.${softwareInfo.i18n_text2}`)  }} 
                        </p>
                    </div>
                </div>
			</div> 
         
		</section>
    </div>
</template>

<script >
import { MixinsList } from '@/mixins/mixins' 
import { loadData } from '@/utils/dataLoader'
export default {
    name: 'mbWeldCloud',
      mixins: [MixinsList],
    data () {
        return {          
            softwareInfo: null,  // 信息
        }
    },
    created() {
        this.getList()  // 获取内容
    },
    mounted () { },
    methods: {
      
        // 获取内容
        async getList() {
            // const { result } = res
           	// this.softwareInfo = result.software[this.$route.query.type]

            //      // lang--在minxins.js中定义
            // if(this.lang == 'en') {
            //     this.softwareInfo.i18n_solutionImg = this.softwareInfo.solutionImg_en
            //     this.softwareInfo.i18n_cloudArchitecture = this.softwareInfo.cloudArchitecture_en
            //     this.softwareInfo.i18n_weldingFlowChart = this.softwareInfo.weldingFlowChart_en
            // }else if(this.lang == 'ru') {

            // } else {
            //      this.softwareInfo.i18n_solutionImg = this.softwareInfo.solutionImg
            //      this.softwareInfo.i18n_cloudArchitecture = this.softwareInfo.cloudArchitecture
            //       this.softwareInfo.i18n_weldingFlowChart = this.softwareInfo.weldingFlowChart
            // }

             try {
                const softwareCloud = await loadData('productSoftwareApp', this.lang)
                this.softwareInfo = softwareCloud[this.$route.query.type]
            } catch (error) {
                 console.error('[mbWeldCloud] 加载失败:', error)
                this.softwareParams = {}
                this.hardwareParams = {}
             }
        },
      

     
    }
}
</script>
<style scoped>
.blog-details {
    padding: 60px 0 60px;
}
body {
	color: var(--notech-black) !important;
}
.page-header-bg {
    background-color: transparent; 
}

.page-header__inner h1{
    text-align: center;
    font-size: var(--font-size-20) !important;
    text-justify: distribute-all-lines;  /*兼容ie*/
 }

.page-header__inner_text{
    /* width: 50%; */
    font-size: 16px;
    margin-top: 13px;
    line-height: 1.75;
    color: var(--notech-white);
 }

 .main-slider .container {
    padding-top: 120px;
    padding-bottom: 120px;
}


 .button_hover:hover {
    /* background: #097cf2 !important; */
    background: var(--notech-base);
}


.row_img {
    max-width: 100%;
}

.rct_aglin {
    margin: 0 auto;
}
/* 产品功能-具体介绍 */
.rf_title {
    line-height: 40px;
    margin-top: 10px;
    font-size: var(--font-size-16);
    font-weight: bold;
}
.rfc_margin {
    margin-top: 20px;
}
.rfc_button_margin {
    margin-top: 35px;
}
.rf_text {
    line-height: 30px;
    font-size: 16px;
    /* font-weight: bold; */
    white-space: normal;
    text-indent: 32px;
}
</style> 
